import { render, staticRenderFns } from "./FestivalHome.vue?vue&type=template&id=167e0f26&scoped=true"
import script from "./FestivalHome.vue?vue&type=script&lang=js"
export * from "./FestivalHome.vue?vue&type=script&lang=js"
import style0 from "./FestivalHome.vue?vue&type=style&index=0&id=167e0f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e0f26",
  null
  
)

export default component.exports